// extracted by mini-css-extract-plugin
export default {"container":"RyDt4H","full":"L8pIaN","narrow":"e644Uc"};